var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"loading-logo-box"},[_c('img',{staticClass:"loading-logo",attrs:{"src":require("@/assets/img/logo_loading.png"),"alt":""}}),_c('div',{staticClass:"loading-tip"},[_vm._v("客户服务费")])]),_c('img',{staticClass:"loading-img",attrs:{"src":require("@/assets/img/loading.gif"),"alt":""}})])
}]

export { render, staticRenderFns }